type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  strokeColor?: string;
};
const TimelineCompositionIcon = (props: Props) => {
  return (
    <svg
      width={props.width || '16'}
      height={props.height || props.width || '16'}
      viewBox={props.viewBox || '0 0 14 14'}
      fill="none"
    >
      <path
        d="M1.5 1.5H12.5V12.5H1.5V1.5ZM4 4H10M7 4V10"
        stroke={props.strokeColor || '#F2D093'}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};

export default TimelineCompositionIcon;
